import { render, staticRenderFns } from "./BtnUpload.vue?vue&type=template&id=ff48e8cc&scoped=true&"
import script from "./BtnUpload.vue?vue&type=script&lang=js&"
export * from "./BtnUpload.vue?vue&type=script&lang=js&"
import style0 from "./BtnUpload.vue?vue&type=style&index=0&id=ff48e8cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff48e8cc",
  null
  
)

export default component.exports